const UserActions = {
    GET_NIP_KIT_START: "GET_NIP_KIT_START",
    GET_NIP_KIT_SUCCESS: "GET_NIP_KIT_SUCCESS",
    GET_NIP_KIT_FAILURE: "GET_NIP_KIT_FAILURE",
    DOWNLOAD_NIP_KIT_START: "DOWNLOAD_NIP_KIT_START",
    DOWNLOAD_NIP_KIT_SUCCESS: "DOWNLOAD_NIP_KIT_SUCCESS",
    DOWNLOAD_NIP_KIT_FAILURE: "DOWNLOAD_NIP_KIT_FAILURE",
    GET_ALL_NIP_APPLICATIONS_START: "GET_ALL_NIP_APPLICATIONS_START",
    GET_ALL_NIP_APPLICATIONS_SUCCESS: "GET_ALL_NIP_APPLICATIONS_SUCCESS",
    GET_ALL_NIP_APPLICATIONS_FAILURE: "GET_ALL_NIP_APPLICATIONS_FAILURE",
    GET_SINGLE_NIP_APPLICATION_START: "GET_SINGLE_NIP_APPLICATION_START",
    GET_SINGLE_NIP_APPLICATION_SUCCESS: "GET_SINGLE_NIP_APPLICATION_SUCCESS",
    GET_SINGLE_NIP_APPLICATION_FAILURE: "GET_SINGLE_NIP_APPLICATION_FAILURE",
    SUBMIT_NIP_APPLICATION_START: "SUBMIT_NIP_APPLICATION_START",
    SUBMIT_NIP_APPLICATION_SUCCESS: "SUBMIT_NIP_APPLICATION_SUCCESS",
    SUBMIT_NIP_APPLICATION_FAILURE: "SUBMIT_NIP_APPLICATION_FAILURE",
    SUBMIT_REQUEST_FOR_PERMIT_START: "SUBMIT_REQUEST_FOR_PERMIT_START",
    SUBMIT_REQUEST_FOR_PERMIT_SUCCESS: "SUBMIT_REQUEST_FOR_PERMIT_SUCCESS",
    SUBMIT_REQUEST_FOR_PERMIT_FAILURE: "SUBMIT_REQUEST_FOR_PERMIT_FAILURE",
    SUBMIT_REQUEST_FORM_START: "SUBMIT_REQUEST_FORM_START",
    SUBMIT_REQUEST_FORM_SUCCESS: "SUBMIT_REQUEST_FORM_SUCCESS",
    SUBMIT_REQUEST_FORM_FAILURE: "SUBMIT_REQUEST_FORM_FAILURE",
    GET_MIGRATION_MONTHS_START: "GET_MIGRATION_MONTHS_START",
    GET_MIGRATION_MONTHS_SUCCESS: "GET_MIGRATION_MONTHS_SUCCESS",
    GET_MIGRATION_MONTHS_FAILURE: "GET_MIGRATION_MONTHS_FAILURE",
    GET_MIGRATION_DAYS_START: "GET_MIGRATION_DAYS_START",
    GET_MIGRATION_DAYS_SUCCESS: "GET_MIGRATION_DAYS_SUCCESS",
    GET_MIGRATION_DAYS_FAILURE: "GET_MIGRATION_DAYS_FAILURE",
    GET_MIGRATION_SLOT_START: "GET_MIGRATION_SLOT_START",
    GET_MIGRATION_SLOT_SUCCESS: "GET_MIGRATION_SLOT_SUCCESS",
    GET_MIGRATION_SLOT_FAILURE: "GET_MIGRATION_SLOT_FAILURE",
    BOOK_MIGRATION_SLOT_START: "BOOK_MIGRATION_SLOT_START",
    BOOK_MIGRATION_SLOT_SUCCESS: "BOOK_MIGRATION_SLOT_SUCCESS",
    BOOK_MIGRATION_SLOT_FAILURE: "BOOK_MIGRATION_SLOT_FAILURE",
    CLEAR_MIGRATION_STATE: "CLEAR_MIGRATION_STATE",
    INITIATE_OUTWARD_TEST_START: "INITIATE_OUTWARD_TEST_START",
    INITIATE_OUTWARD_TEST_SUCCESS: "INITIATE_OUTWARD_TEST_SUCCESS",
    INITIATE_OUTWARD_TEST_FAILURE: "INITIATE_OUTWARD_TEST_FAILURE",
    RUN_NAME_ENQUIRY_TEST_START: "RUN_NAME_ENQUIRY_TEST_START",
    RUN_NAME_ENQUIRY_TEST_SUCCESS: "RUN_NAME_ENQUIRY_TEST_SUCCESS",
    RUN_NAME_ENQUIRY_TEST_FAILURE: "RUN_NAME_ENQUIRY_TEST_FAILURE",
    RUN_FUND_TRANSFER_TEST_START: "RUN_FUND_TRANSFER_TEST_START",
    RUN_FUND_TRANSFER_TEST_SUCCESS: "RUN_FUND_TRANSFER_TEST_SUCCESS",
    RUN_FUND_TRANSFER_TEST_FAILURE: "RUN_FUND_TRANSFER_TEST_FAILURE",
    RUN_STATUS_QUERY_TEST_START: "RUN_STATUS_QUERY_TEST_START",
    RUN_STATUS_QUERY_TEST_SUCCESS: "RUN_STATUS_QUERY_TEST_SUCCESS",
    RUN_STATUS_QUERY_TEST_FAILURE: "RUN_STATUS_QUERY_TEST_FAILURE",
    SUBMIT_OUTWARD_TEST_START: "SUBMIT_OUTWARD_TEST_START",
    SUBMIT_OUTWARD_TEST_SUCCESS: "SUBMIT_OUTWARD_TEST_SUCCESS",
    SUBMIT_OUTWARD_TEST_FAILURE: "SUBMIT_OUTWARD_TEST_FAILURE",
    CLEAR_NIP_TEST_STATE: "CLEAR_NIP_TEST_STATE",
    UPLOAD_KEY_START: "UPLOAD_KEY_START",
    UPLOAD_KEY_SUCCESS: "UPLOAD_KEY_SUCCESS",
    UPLOAD_KEY_FAILURE: "UPLOAD_KEY_FAILURE",
    CLEAR_NIP_STATE: "CLEAR_NIP_STATE",
  };
  
  export default UserActions;